import request from 'utils/request';
import { getErrorFromStorage } from 'utils/error';

export const sendRequest = (error: ReturnType<typeof getErrorFromStorage>) =>
  request({
    url: '/error/report',
    method: 'post',
    data: error,
  });

export const sendNetworkErrorRequest = (error: ReturnType<typeof getErrorFromStorage>) =>
  request({
    url: '/error/networkError',
    method: 'post',
    data: error,
  });
